import { useMemo, type FC } from 'react'

import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'

type PageGuardPengawasProps = React.HTMLAttributes<HTMLDivElement> & {
  accessibleByKepalaDinas?: boolean
}

const PageGuardPengawas: FC<PageGuardPengawasProps> = ({
  children,
  accessibleByKepalaDinas = false,
}) => {
  const {
    isLoading: isLoadingRole,
    isPengawasSekolahOnly,
    isKepalaDinasAndPengawasSekolah,
    leave,
  } = useRoleContext()

  const canAccess = useMemo(() => {
    let allowed = false

    // Allow if the user is Pengawas Sekolah and not Kepala Dinas
    if (isPengawasSekolahOnly) allowed = true

    // Allow if the user is both Kepala Dinas and Pengawas Sekolah and the page is accessible by Kepala Dinas
    if (isKepalaDinasAndPengawasSekolah && accessibleByKepalaDinas)
      allowed = true

    return allowed
  }, [
    accessibleByKepalaDinas,
    isKepalaDinasAndPengawasSekolah,
    isPengawasSekolahOnly,
  ])

  if (!isLoadingRole && !canAccess) leave()

  // As the component should not be rendered when still loading the user role, we can just return null
  if (isLoadingRole) return null

  return <>{children}</>
}
export default PageGuardPengawas
